var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',{staticClass:"flix-html-h3"},[_vm._v(_vm._s(_vm.$tc('message.calendar', 2))+": "+_vm._s(_vm.$tc('message.color', 1)))]),_c('flixColorpicker',{attrs:{"open":false,"value":_vm.styling.accent,"callback":function (value) { _vm.styling.accent = value; _vm.setValue() }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }